"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventBandBanner = exports.BandBannerView = exports.splitCtaLines = exports.toSafeHref = void 0;
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const styled_components_1 = __importDefault(require("styled-components"));
const common_1 = require("../../../common");
const GlobalStateProvider_1 = require("../../../GlobalStateProvider");
const banner_1 = require("../../../server/banner");
const classes_1 = require("../classes");
/* ────────────────────────────────────────────────────────────────────────────
 * 대인라 하단 띠배너
 *
 * 문구·버튼·링크는 관리자 페이지(클래스 관리 > 배너 관리)에서 설정하고
 * GET /api/mimac/v1/banner?class_id= 로 받는다. 코드 수정 없이 운영에서 교체한다.
 *
 * 운영 규칙
 *  - 노출 우선순위: 클래스 개별 설정 → 없으면 전체(기본) 배너 → 둘 다 없으면(result null) 미노출.
 *  - 노출 종료: 관리자가 배너를 삭제하면 된다(별도 종료 시각 없음). 켜둔 화면은 탭 복귀 시 재조회해 반영.
 *  - 닫기(X): 브라우저 세션 단위 숨김(sessionStorage). 키에 배너 내용 지문이 들어가므로
 *    문구·링크 중 하나라도 바뀌면 이전 배너를 닫아둔 세션에도 새 배너가 노출된다.
 *  - 클릭: X 를 제외한 배너 전체가 링크. 새 탭으로 열림(수업 화면 이탈 방지). 링크가 비어 있으면 클릭 무동작.
 *  - 모바일 버튼 문구: 공백 기준 2줄(공백이 없으면 절반)로 세로 배치 — 기존 '수강/신청' 레이아웃 유지.
 * ──────────────────────────────────────────────────────────────────────────── */
const COLOR_BG = '#212937';
const COLOR_POINT = '#F3C13F';
const COLOR_DESC = '#E2E3E5';
/**
 * 관리자가 입력한 링크를 href 로 쓸 수 있게 정규화한다.
 * http(s) 절대주소·사이트 내 경로(/...)만 허용하고, 스킴 없는 도메인은 https:// 를 붙인다.
 * javascript:/data: 등 그 외 스킴은 undefined(링크 없음) — 배너 전체가 <a> 라 XSS 경로가 되면 안 된다.
 */
const toSafeHref = (link) => {
    const value = (link ?? '').trim();
    if (!value)
        return undefined;
    if (/^https?:\/\//i.test(value))
        return value;
    if (/^\/(?!\/)/.test(value))
        return value;
    if (/^[\w.-]+\.[a-z]{2,}(?::\d+)?(?:[/?#].*)?$/i.test(value))
        return `https://${value}`;
    return undefined;
};
exports.toSafeHref = toSafeHref;
/** 모바일 CTA 를 2줄로 나눈다: 공백이 있으면 첫 공백 기준, 없으면 절반(3자 이하는 1줄) */
const splitCtaLines = (text) => {
    const value = text.trim();
    if (!value)
        return [];
    const words = value.split(/\s+/);
    if (words.length >= 2)
        return [words[0], words.slice(1).join(' ')];
    if (value.length <= 3)
        return [value];
    const half = Math.ceil(value.length / 2);
    return [value.slice(0, half), value.slice(half)];
};
exports.splitCtaLines = splitCtaLines;
/** 배너 내용 지문 — 닫기 상태 저장 키에 사용(내용이 바뀌면 다른 키) */
const bannerFingerprint = (banner) => {
    const source = [
        banner.class_id,
        banner.title,
        banner.description,
        banner.button_text,
        banner.button_link,
    ].join('|');
    let hash = 5381;
    for (let i = 0; i < source.length; i++) {
        hash = ((hash << 5) + hash + source.charCodeAt(i)) | 0;
    }
    return (hash >>> 0).toString(36);
};
const closedStorageKey = (banner) => `mimac.bandBanner.${bannerFingerprint(banner)}.closed`;
const readClosed = (key) => {
    try {
        return sessionStorage.getItem(key) === '1';
    }
    catch (e) {
        // 사파리 프라이빗 등 스토리지 접근 차단 환경 — 닫기는 렌더 상태로만 유지
        return false;
    }
};
const BandStyled = styled_components_1.default.div `
	position: ${props => (props.$inline ? 'relative' : 'fixed')};
	left: 0;
	right: 0;
	bottom: ${props => (props.$inline ? 'auto' : `${props.$bottom}px`)};
	/*
	 * z-index 2 = 팝업(.popup)과 같은 층. 팝업/다이얼로그는 DOM 상 뒤(App 루트)에 그려져
	 * 동률에서 이기므로 배너가 팝업을 덮지 않고, 모바일 GNB 드로어(z-index 5)·드롭다운(22)
	 * 보다도 아래에 남는다. 반대로 일반 콘텐츠(auto/0/1) 위에는 정상적으로 뜬다.
	 */
	z-index: 2;
	background: ${COLOR_BG};
	height: ${props => (props.$isMobile ? 52 : 72)}px;
	width: 100%;
	box-sizing: border-box;

	.band-link {
		display: flex;
		align-items: center;
		gap: ${props => (props.$isMobile ? 8 : 16)}px;
		width: 100%;
		height: 100%;
		padding: ${props => (props.$isMobile ? '0 44px 0 12px' : '0 64px 0 48px')};
		box-sizing: border-box;
		text-decoration: none;
		cursor: pointer;

		&.no-link {
			cursor: default;
		}
	}

	.band-icon {
		flex-shrink: 0;
		display: flex;
		align-items: center;
		justify-content: center;
		width: ${props => (props.$isMobile ? 18 : 24)}px;
		height: ${props => (props.$isMobile ? 18 : 24)}px;
		border-radius: 50%;
		background: ${COLOR_POINT};
		color: ${COLOR_BG};
		font-size: ${props => (props.$isMobile ? 12 : 15)}px;
		font-weight: 700;
		line-height: 1;
	}

	.band-text {
		display: flex;
		flex-direction: column;
		gap: 2px;
		flex: 1;
		min-width: 0;
	}

	.band-title {
		color: #ffffff;
		font-size: ${props => (props.$isMobile ? 13 : 16)}px;
		font-weight: 700;
		line-height: 1.35;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	.band-desc {
		color: ${COLOR_DESC};
		font-size: ${props => (props.$isMobile ? 11 : 13)}px;
		font-weight: 500;
		line-height: 1.35;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	.band-cta {
		flex-shrink: 0;
		display: flex;
		align-items: center;
		justify-content: center;
		gap: 6px;
		border: 1px solid ${COLOR_POINT};
		border-radius: 999px;
		color: ${COLOR_POINT};
		font-weight: 700;
		${props => props.$isMobile
    ? `
		flex-direction: column;
		gap: 0;
		min-width: 52px;
		padding: 5px 10px;
		font-size: 12px;
		line-height: 1.25;
		text-align: center;
		`
    : `
		padding: 11px 24px;
		font-size: 14px;
		line-height: 1;
		`}
	}

	.band-close {
		position: absolute;
		${props => (props.$isMobile ? 'top: 4px; right: 6px;' : 'top: 50%; right: 20px; transform: translateY(-50%);')}
		display: flex;
		align-items: center;
		justify-content: center;
		padding: ${props => (props.$isMobile ? 4 : 6)}px;
		border: none;
		background: transparent;
		color: #ffffff;
		cursor: pointer;
		line-height: 0;
	}
`;
/**
 * 띠배너 표시부(순수 렌더). 포털 실배너와 관리자 미리보기가 같은 컴포넌트를 쓴다.
 */
exports.BandBannerView = react_1.default.memo(({ banner, isMobile, bottom = 0, inline = false, onClose, className }) => {
    const href = (0, react_1.useMemo)(() => (0, exports.toSafeHref)(banner.button_link), [banner.button_link]);
    const cta = banner.button_text.trim();
    const ctaLines = (0, react_1.useMemo)(() => (0, exports.splitCtaLines)(banner.button_text), [banner.button_text]);
    // 링크가 없으면 <a> 대신 <div> — 빈 href 로 현재 페이지가 새 탭에 열리는 것 방지
    const LinkTag = (href ? 'a' : 'div');
    const linkProps = href ? { href, target: '_blank', rel: 'noopener noreferrer' } : {};
    return (react_1.default.createElement(BandStyled, { className: `event-band-banner ${className ?? ''}`, "$bottom": bottom, "$isMobile": isMobile, "$inline": inline },
        react_1.default.createElement(LinkTag, { className: `band-link ${href ? '' : 'no-link'}`, ...linkProps },
            react_1.default.createElement("span", { className: "band-icon", "aria-hidden": true }, "!"),
            react_1.default.createElement("span", { className: "band-text" },
                react_1.default.createElement("span", { className: "band-title" }, banner.title),
                banner.description && react_1.default.createElement("span", { className: "band-desc" }, banner.description)),
            cta && (react_1.default.createElement("span", { className: "band-cta" }, isMobile ? (ctaLines.map((line, idx) => react_1.default.createElement("span", { key: `${idx}-${line}` }, line))) : (react_1.default.createElement(react_1.default.Fragment, null,
                cta,
                react_1.default.createElement("span", { "aria-hidden": true }, ">")))))),
        onClose && (react_1.default.createElement("button", { type: "button", className: "band-close", "aria-label": "\uBC30\uB108 \uB2EB\uAE30", onClick: onClose },
            react_1.default.createElement(common_1.Icon, { icon: "close", size: isMobile ? 14 : 20, fill: "#ffffff" })))));
});
/**
 * 포털 하단 띠배너(데이터 연동부). 현재 클래스 기준으로 서버 배너를 조회해 표시한다.
 */
exports.EventBandBanner = react_1.default.memo(() => {
    const { isMobile, isTablet } = (0, GlobalStateProvider_1.useGlobalState)();
    const classId = (0, react_redux_1.useSelector)((state) => (0, classes_1.getClasses)(state)?.id);
    const [banner, setBanner] = (0, react_1.useState)(null);
    const [closed, setClosed] = (0, react_1.useState)(false);
    // 모바일/태블릿은 하단 네비(.bottom-nav) 위에 얹는다. 네비 높이는 실측(폰트 크기·안전영역 등으로 달라짐)
    const [bottomOffset, setBottomOffset] = (0, react_1.useState)(0);
    const load = (0, react_1.useCallback)(async () => {
        const targetId = classId ?? (0, classes_1.getClassesId)();
        // 클래스 컨텍스트가 없으면 조회하지 않는다(빈 class_id 요청 금지) — 배너 미노출
        if (!targetId)
            return null;
        try {
            const response = await (0, banner_1.getBanner)(targetId);
            return response?.result ?? null;
        }
        catch (error) {
            // 조회 실패는 미노출로 처리 — 배너 때문에 수업 화면이 막히면 안 된다
            console.warn('[EventBandBanner] 배너 조회 실패 — 미노출', error);
            return null;
        }
    }, [classId]);
    (0, react_1.useEffect)(() => {
        let cancelled = false;
        const run = () => load().then(item => {
            if (!cancelled)
                setBanner(item);
        });
        run();
        // 오래 켜둔 탭에서도 관리자 변경(교체·삭제)이 복귀 시점에 반영되도록 재조회
        const onVisibilityChange = () => {
            if (!document.hidden)
                run();
        };
        document.addEventListener('visibilitychange', onVisibilityChange);
        return () => {
            cancelled = true;
            document.removeEventListener('visibilitychange', onVisibilityChange);
        };
    }, [load]);
    // 배너 내용이 바뀌면 키가 달라져 닫기 상태가 리셋된다
    const storageKey = (0, react_1.useMemo)(() => (banner ? closedStorageKey(banner) : null), [banner]);
    (0, react_1.useEffect)(() => {
        setClosed(storageKey ? readClosed(storageKey) : false);
    }, [storageKey]);
    const visible = !!banner && banner.title.trim().length > 0 && !closed;
    (0, react_1.useEffect)(() => {
        if (!visible || !(isMobile || isTablet)) {
            setBottomOffset(0);
            return;
        }
        const nav = document.querySelector('.bottom-nav');
        if (!nav) {
            setBottomOffset(0);
            return;
        }
        const update = () => setBottomOffset(nav.offsetHeight);
        update();
        const observer = new ResizeObserver(update);
        observer.observe(nav);
        return () => observer.disconnect();
    }, [visible, isMobile, isTablet]);
    const handlerClose = (e) => {
        // 배너 전체가 링크라 닫기 클릭이 링크로 전파되면 안 된다
        e.preventDefault();
        e.stopPropagation();
        if (storageKey) {
            try {
                sessionStorage.setItem(storageKey, '1');
            }
            catch (error) {
                // 스토리지 차단 환경 — 이번 렌더에서만 숨김
            }
        }
        setClosed(true);
    };
    if (!visible || !banner)
        return null;
    return (react_1.default.createElement(exports.BandBannerView, { banner: banner, isMobile: isMobile, bottom: bottomOffset, onClose: handlerClose }));
});
exports.default = exports.EventBandBanner;
